import { type EligibilityCheckPayload } from '@/modules/api';

import { ELIGIBILITY_CHECK_FIELDS } from '../constants/eligibilityCheckFields';
import { OnboardingDataDraft } from '../types/onboardingDataDraft';

import { pick } from './pick';

export function buildCheckEligibilityPayload(draft: OnboardingDataDraft): EligibilityCheckPayload {
  const basePayload: EligibilityCheckPayload = {
    vidaUserUuid: draft.userUuid,
    dateOfBirth: draft.dateOfBirth,
    firstName: draft.firstName,
    lastName: draft.lastName,
    orgUuid: draft.orgUuid,
    // Backend expects the single-char enum (M/F/O); default unspecified to 'O'.
    gender: draft.gender || 'O',
    employeeId: draft.employeeId,
    email: draft.email,
    isTester: draft.isTester === true,
  };

  switch (draft.orgEligibilityCheckFields) {
    case ELIGIBILITY_CHECK_FIELDS.FN_LN_DOB_OR_EMPID_DOB:
    case ELIGIBILITY_CHECK_FIELDS.FN_LN_DOB_EMPID:
      return pick(basePayload, [
        'firstName',
        'lastName',
        'dateOfBirth',
        'employeeId',
        'orgUuid',
        'vidaUserUuid',
        'isTester',
      ]);

    case ELIGIBILITY_CHECK_FIELDS.FN_LN_DOB_AND_EMPID_OR_ZC:
      return pick(
        {
          ...basePayload,
          zipcode: draft.zipCode,
        },
        [
          'firstName',
          'lastName',
          'dateOfBirth',
          'employeeId',
          'zipcode',
          'orgUuid',
          'vidaUserUuid',
          'isTester',
        ]
      );

    case ELIGIBILITY_CHECK_FIELDS.FN_LN_DOB_EMPID_EMAIL_GENDER:
      if (draft.selectHealthPlan && draft.healthPlanUuid) {
        if (draft.healthPlanHolderRelation === 'self') {
          return {
            ...basePayload,
            healthPlanUuid: draft.healthPlanUuid,
            healthPlanHolderRelation: draft.healthPlanHolderRelation,
          };
        }
        return {
          ...basePayload,
          healthPlanUuid: draft.healthPlanUuid,
          healthPlanHolderRelation: draft.healthPlanHolderRelation,
          healthPlanHolderFirstName: draft.healthPlanHolderFirstName,
          healthPlanHolderLastName: draft.healthPlanHolderLastName,
          healthPlanHolderBirthday: draft.healthPlanHolderBirthday,
          healthPlanHolderGender: draft.healthPlanHolderGender,
        };
      }
      return basePayload;

    default:
      return pick(basePayload, [
        'firstName',
        'lastName',
        'dateOfBirth',
        'orgUuid',
        'vidaUserUuid',
        'isTester',
      ]);
  }
}
